import axios from 'axios'

class SignupClient {
    static getCountryCode() {
        return axios.get('https://ipapi.co/json/').then(
            (response) => {
                const data = response.data
                return data.country_code
            }
        )
    }

    static signup(
        name: string,
        companyName: string,
        email: string,
        phone: string,
        newsletter: boolean,
        countryCode: string,
        language: string,
        gRecaptchaToken: string,
        signupReferral: string|null
    ) {
        return axios.post(
            '/api/anonymous/account/signup',
            {
                full_name: name,
                company_name: companyName,
                email,
                phone_number: phone,
                newsletter,
                country_code: countryCode,
                language,
                g_recaptcha_token: gRecaptchaToken,
                signup_referral: signupReferral,
            }
        )
    }
}

export default SignupClient
